module.exports = __webpack_public_path__ + "static/media/telegram.01f9bcbc.svg";